import styled from 'styled-components'

import pxToRem from '../../utils/pxToRem'
import SliderArrow from '../../images/icons/slider-left.svg'

import Heading from '../Heading/Heading'
import { deviceMax } from '../../theme/breakpoints'
import CKEditorContent from '../CKEditorContent/CKEditorContent'

export const StyledSlider = styled.section`
  padding: ${pxToRem(20)};
  max-width: ${pxToRem(792)};
  width: 100%;
  border-radius: ${pxToRem(5)};
  background-color: ${({ theme }) => theme.colors.unique.white};
  @media ${deviceMax.mobileL} {
    border-radius: initial;
  }
`

export const StyledSliderHeader = styled.div`
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
  display: flex;
  width: 100%;
  margin-bottom: ${pxToRem(10)};
`

export const StyledTitle = styled(Heading)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
`

export const StyledSliderControls = styled.div`
  display: flex;
  margin-left: auto;
`

export const StyledImageContainer = styled.div`
  display: flex;
  height: ${({ isActive }) => (isActive ? pxToRem(400) : pxToRem(250))};
  width: ${({ isActive }) => (isActive ? pxToRem(400) : pxToRem(250))};
  min-height: ${({ isActive }) => (isActive ? pxToRem(400) : pxToRem(250))};
  min-width: ${({ isActive }) => (isActive ? pxToRem(400) : pxToRem(250))};
  cursor: pointer;
  transition: all 0.5s ease;

  @media ${deviceMax.mobileL} {
    height: ${({ isActive }) => (isActive ? pxToRem(280) : pxToRem(200))};
    width: ${({ isActive }) => (isActive ? pxToRem(280) : pxToRem(200))};
    min-height: ${({ isActive }) => (isActive ? pxToRem(280) : pxToRem(200))};
    min-width: ${({ isActive }) => (isActive ? pxToRem(280) : pxToRem(200))};
  }

  img {
    border-radius: ${pxToRem(5)};
    object-fit: cover;
  }
`

export const StyledOverlay = styled.div`
  gap: ${pxToRem(20)};
  display: flex;
  padding-right: ${pxToRem(400)};
  width: calc(
    ${({ nbOfSlides }) => pxToRem(nbOfSlides * 500)} + ${pxToRem(792)}
  );
  height: ${pxToRem(400)};
  transform: translateX(${({ position }) => pxToRem(-position * 270)});
  transition: transform 0.5s ease;

  @media ${deviceMax.mobileL} {
    gap: ${pxToRem(10)};
    height: ${pxToRem(280)};
    transform: translateX(${({ position }) => pxToRem(-position * 210)});
  }
`

export const StyledSlides = styled.div`
  overflow: hidden;
  margin: 0 ${pxToRem(-20)} ${pxToRem(20)} 0;
`

export const SliderArrowLeft = styled(SliderArrow)``

export const SliderArrowRight = styled(SliderArrow)`
  transform: rotate(180deg);
`

export const StyledSlidesInfos = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${pxToRem(10)};
  border-left: ${pxToRem(3)} solid ${({ theme }) => theme.colors.primary.lime};
`

export const StyledInfos = styled.div`
  display: ${({ isActive }) => (isActive ? 'flex' : 'none')};
  flex-direction: column;
`

export const StyledInfosTitle = styled(Heading)`
  margin-bottom: ${pxToRem(10)};
`

export const StyledCKEditorContent = styled(CKEditorContent)`
  margin-bottom: ${pxToRem(-10)};
`
